module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"countdown\">\n    <div class=\"countdown__group countdown__group--days\">\n        <div class=\"countdown__wrap countdown__wrap--days\">\n        </div>\n        <div class=\"countdown__label\">\n            <%= getLocale('day_abbreviation') %>\n        </div>\n    </div>\n    <div class=\"countdown__group countdown__group--hours\">\n        <div class=\"countdown__wrap countdown__wrap--hours\">\n        </div>\n        <div class=\"countdown__label\">\n            <%= getLocale('hour_abbreviation') %>\n        </div>\n    </div>\n    <div class=\"countdown__group countdown__group--minutes\">\n        <div class=\"countdown__wrap countdown__wrap--minutes\">\n        </div>\n        <div class=\"countdown__label\">\n            <%= getLocale('minute_abbreviation') %>\n        </div>\n    </div>\n    <div class=\"countdown__group countdown__group--seconds\">\n        <div class=\"countdown__wrap countdown__wrap--seconds\">\n        </div>\n        <div class=\"countdown__label\">\n            <%= getLocale('second_abbreviation') %>\n        </div>\n    </div>\n\n    <div class=\"countdown__live\">\n        <span class=\"countdown__live--reddot\"></span>\n        <span class=\"countdown__live--label\"><%= getLocale('live') %></span>\n    </div>\n</div>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/__countdown.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<div class=\"countdown\">\n    <div class=\"countdown__group countdown__group--days\">\n        <div class=\"countdown__wrap countdown__wrap--days\">\n        </div>\n        <div class=\"countdown__label\">\n            ")
    ; __line = 6
    ; __append(escapeFn( getLocale('day_abbreviation') ))
    ; __append("\n        </div>\n    </div>\n    <div class=\"countdown__group countdown__group--hours\">\n        <div class=\"countdown__wrap countdown__wrap--hours\">\n        </div>\n        <div class=\"countdown__label\">\n            ")
    ; __line = 13
    ; __append(escapeFn( getLocale('hour_abbreviation') ))
    ; __append("\n        </div>\n    </div>\n    <div class=\"countdown__group countdown__group--minutes\">\n        <div class=\"countdown__wrap countdown__wrap--minutes\">\n        </div>\n        <div class=\"countdown__label\">\n            ")
    ; __line = 20
    ; __append(escapeFn( getLocale('minute_abbreviation') ))
    ; __append("\n        </div>\n    </div>\n    <div class=\"countdown__group countdown__group--seconds\">\n        <div class=\"countdown__wrap countdown__wrap--seconds\">\n        </div>\n        <div class=\"countdown__label\">\n            ")
    ; __line = 27
    ; __append(escapeFn( getLocale('second_abbreviation') ))
    ; __append("\n        </div>\n    </div>\n\n    <div class=\"countdown__live\">\n        <span class=\"countdown__live--reddot\"></span>\n        <span class=\"countdown__live--label\">")
    ; __line = 33
    ; __append(escapeFn( getLocale('live') ))
    ; __append("</span>\n    </div>\n</div>\n")
    ; __line = 36
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/__countdown.tpl"

}